// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@awc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { mergeWithCss } from "@awc/XDL/Utilities";
import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { css } from "styled-components";

savedOrderListFilterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
    offsetCss: css`
        align-items: start;
    `,
};

savedOrderListFilterStyles.orderTotalAmountTextField = {
    ...myAccountFilterSectionStyles.orderTotalAmountTextField,
};

savedOrderListFilterStyles.fromDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.fromDate, {
        cssOverrides: {
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};

savedOrderListFilterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

savedOrderListFilterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};

savedOrderListFilterStyles.datesGridItem = {
    width: [12, 12, 12, 4, 4],
};

savedOrderListFilterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

savedOrderListFilterStyles.toDate = {
    ...mergeWithCss(myAccountFilterSectionStyles.toDate, {
        cssOverrides: {
            formInputWrapper: css`
                &&& {
                    .react-datetime-picker {
                        min-height: 42px;
                    }
                }
            `,
        },
    }),
};

savedOrderListFilterStyles.datesContainer = {
    gap: 12,
};

savedOrderListFilterStyles.fromGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

savedOrderListFilterStyles.toGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

savedOrderListFilterStyles.buttonsItem = {
    width: [12, 12, 12, 4, 4],
    css: css`
        align-items: flex-end;
        justify-content: flex-end;
        align-self: flex-end;
    `,
};

savedOrderListFilterStyles.orderTotalGridItem = {
    width: [12, 12, 12, 4, 4],
};

savedOrderListFilterStyles.orderTotalContainer = {
    gap: 12,
};

savedOrderListFilterStyles.orderTotalOperatorGridItem = {
    width: [12, 12, 6, 6, 6],
};

savedOrderListFilterStyles.orderTotalAmountGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        align-items: flex-end;
    `,
};
